/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { BydModel } from '@sixense/byd-core-service';
import { DsPin } from '../../ds-pins/models/ds-pin';
/** Interfaces */
import { DsPinInterface } from '../../ds-pins/interfaces/ds-pin.interface';
/** Constants */
import { DS_MAPS_BASE_URL } from '../constants/ds-maps-base-url.constant';

@Injectable({
  providedIn: 'root',
})
/**
 * Service for fetching 2D map pins.
 */
export class DsMapPinsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get all the pins present on the given 2D map.
   *
   * @param projectId The project id.
   * @param mapId The map id
   * @returns Observable of <BydModel<DsPin>>
   */
  public getPins(projectId: number, mapId: number): Observable<BydModel<DsPin>> {
    this.path = `${DS_MAPS_BASE_URL}${projectId}/maps/2D/${mapId}/pins`;
    return this.getModels<DsPin>();
  }

  /**
   * Create DsPin instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsPin` instance.
   */
  public createNewInstance(jsonObject: DsPinInterface): DsPin {
    return new DsPin(jsonObject);
  }
}
